import { Controller } from "stimulus"

const excludedParentTagname = [
  'MAIN',
  'BODY'
]
class ScrollEffects extends Controller {
  static targets = [
    'anchor'
  ]

  connect() {
    const customClassesString = this.data.get('customClasses');
    const customClasses = customClassesString ? JSON.parse(customClassesString) : ['t-underline'];
    this.anchorTargets.forEach(anchorElement => {
      const anchorTargetSelector = anchorElement.getAttribute('href');
      const target = document.querySelector(anchorTargetSelector);
      const anchorTarget = excludedParentTagname.includes(target.parentNode.tagName) ? target : target.parentNode;
      document.addEventListener('scroll', () => {
        const { y, height } = anchorTarget.getBoundingClientRect();
        if (y > 60 - height && y < 60) {
          anchorElement.classList.add(...customClasses)
        } else {
          anchorElement.classList.remove(...customClasses)
        }
      })
    })
  }
}

export default ScrollEffects;

